import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../Vas';

import '../css/Login.css';

import { ExtendedButton,TextField,LinkButton,MessageBox,Loading } from 'component-lib';
import { AccountsModel, RequestAjaxClass, PaymentsModel } from 'models-lib';
import { DateTimeHelper } from 'utils-lib';

var moment = require('moment');
        moment().format();
class Login extends Component {

    constructor(props){
      super(props);
      this.Request =  new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
      this.Request2 =  new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
      this.AccountsModel = new AccountsModel([this],null,this.Request);
      this.PaymentsModel = new PaymentsModel([this],null,this.Request2);

      this.AdminConfig = Vas.Config.Administrator;
    }

    componentWillMount(){
        localStorage.removeItem("anonymous_token");
        localStorage.removeItem('vas_token');

        //Hier die Infos für die Vertragsübersicht aus dem LocalStorage löschen
        localStorage.removeItem('CustomerOfAge');
        localStorage.removeItem('ContractOverviewCustomer');
        localStorage.removeItem('ContractOverviewCustomerBirthdate');
        localStorage.removeItem('ContractOverviewCustomerPayment');
        localStorage.removeItem('ContractOverviewTariffPointFrom');
        localStorage.removeItem('ContractOverviewTariffPointTo');
        localStorage.removeItem('ContractOverviewTariffProduct');
        localStorage.removeItem('ContractOverviewContractStart');
        localStorage.removeItem('ContractOverviewContractEnd');
        localStorage.removeItem('LegalGuardian');
        localStorage.removeItem('LegalGuardianBirthDate');

        localStorage.removeItem('ContractOverviewTariffPointFromAtg');
        localStorage.removeItem('ContractOverviewTariffPointToAtg');

        //Hier die Angaben zur Vertragsanlage löschen, da der Dokumentenupload ebenfalls erfolgreich war
        localStorage.removeItem("CustomerId");
        localStorage.removeItem("ContractNUmber");
        localStorage.removeItem("ExecutingForm");

        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setApiUrl(Vas.ApiUrl);
        

        this.Request2.setApiKey(Vas.ApiKey);
        this.Request2.setApiUrl(Vas.ApiUrl);
        this.Request2.setErrorHandler(()=>{
          ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
        });
    }
    
    componentDidMount()
    {
        $("#username").focus();
        let me = this;
        $(document).keyup(function(e) {
            switch (e.which){
                case 13:{//Enter
                  me.login();
                  break;
                }
                default:break;
            }
        });
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "Login"){
          localStorage.removeItem('Password')
          localStorage.setItem("vas_selectedTab","PersonalDataLink");

          me.Request.setAuth(true);
          me.AccountsModel.Own();
        }
        else if(observer === "AccountsOwn"){
          if(me.AccountsModel.Role === 5){
            localStorage.setItem("vas_role", "3");
            if(localStorage.getItem("vas_customerId")){
              if(this.AdminConfig.ShowPanels === true){
                Vas.GetView('Home',null,true);
              }else{
                Vas.GetView('Contracts',null,true);
              }
            }else{
              me.AccountsModel.Own();
            }
            
            
          }else if(me.AccountsModel.Role === 1){
            if(localStorage.getItem('Tariff') !== null && localStorage.getItem('Tariff') !== undefined){
              this.PaymentsModel.GetPaymentsByCustomerId(me.AccountsModel.Customer.Id,null, null, null, null, null, 4);
            }else{
              if(me.AccountsModel.Customer.Id){
                Vas.GetView("CustomerCard",{Id:me.AccountsModel.Customer.Id},true);
              }
              
              //window.location = "customercard/" + me.AccountsModel.Customer.Id;
              //ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
            }
          }else if(me.AccountsModel.Role === 3){
            if(this.AdminConfig.ShowPanels === true){
              Vas.GetView('Home',null,true);
            }else{
              Vas.GetView('Contracts',null,true);
            }
          }
        }
        else if(observer === "Payment"){
          if(this.PaymentsModel.Payments.length > 0){
            let valid = false;
            let today = moment();
            me.PaymentsModel.Payments.forEach(p => {
                if(p.ValidFrom !== null){
                    if(today.isAfter(DateTimeHelper.StringToDate(p.ValidFrom,true, localStorage.getItem('vas_language'))) === true){
                        valid = true;
                    }
                }else{
                    valid = true;
                }
            })
            if(valid === true){
              Vas.GetView('Order',{CustomerId:me.AccountsModel.Customer.Id, ContractId:'00000'},true);
            }else {
              Vas.GetView("NoPayment", { CustomerId: me.AccountsModel.Customer.Id, NewContract : "false" }, true);
            }
          }
          else{
            Vas.GetView("NoPayment",{CustomerId:me.AccountsModel.Customer.Id, NewContract : "false"},true);
          }
        }
      })
    }
    
    login(){
      
      $('#password').val(localStorage.getItem('Password'));

      if ($('#username')){
        if ($('#username').val() !== null && $('#username').val() !== undefined && $('#password').val() !== null && $('#password').val() !== undefined){
          if (($('#username').val().length !== 0)&&($('#password').val().length !== 0)){
            ReactDOM.render(<Loading modal={true} />,document.getElementById('messageContainer'));
            this.AccountsModel.Login($('#username').val(),$('#password').val());
          } else {
           /* ReactDOM.render(<MessageBox
              Message={Vas.Resources.Labels["NotAllFields"]}
              Title={Vas.Resources.Titles["Note"]} />,document.getElementById('messageContainer'));*/
          }
        }
      }

      this.LogoClick();
    };

    ShowResetPassword(){
      Vas.GetView("ResetPassword", null, false);
    }

    savePassword(){
      localStorage.setItem('Password', $('#password').val());
    }

    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');
  
      if(kontrastNumber == "true"){
          $(".loader").attr('style', 'border-top: 16px solid #1d5c87; border-bottom: 16px solid #1d5c87;');        
      }
    }

    render()
    {
        if (localStorage.getItem("ExpiredToken") === "expiredToken"){
            
            localStorage.removeItem("ExpiredToken");
            ReactDOM.render(<MessageBox 
              AppURL={Vas.ApplicationUrl}  
              Title={Vas.Resources.Titles["Error"]} 
              Message={Vas.Resources.Labels["ExpiredToken"]} /> 
                , document.getElementById('messageContainer'));
        }

        $('#password').val(localStorage.getItem('Password'));

        return (
          <div >
            <div className="LoginContainer">
              <div
                className={"loginform"}
                style={{ textAlign:'left' }}>
                <div>
                  <h2>{Vas.Resources.Menus["Login"]}</h2><br />
                </div>
 
                {/*<div><b>{Vas.Resources.Labels["Username"]}</b>: {Vas.Resources.Labels["EmailRegistration"]}</div>*/}

                <div>
                  <TextField 
                    AppURL={Vas.ApplicationUrl} 
                    Editable={true} 
                    name='username' 
                    Id="username" 
                    Label={Vas.Resources.Labels["E-Mail-Address"]} 
                    Tooltip={Vas.Resources.Tooltips["Username"]}
                    onKeyPress={(ev) => { 
                                            if (ev.key === 'Enter') {
                                                $("#password").focus();
                                            }
                                        }} />
                </div>
                <br />
                <br />
                <div>
                  <TextField 
                    AppURL={Vas.ApplicationUrl} 
                    Type={"password"} 
                    Editable={true} 
                    name='password' 
                    Id="password" 
                    Label={Vas.Resources.Labels["Password"]} 
                    Tooltip={Vas.Resources.Tooltips["Pwd"]}
                    OnChange={()=>{ this.savePassword(); }}
                    onKeyPress={(ev) => {
                                            if (ev.key === 'Enter') {
                                              $('#password').val(localStorage.getItem('Password'));
                                                this.login();
                                            }
                                        }} />
                  <br />
                </div>
                <div className="LoginButtonsContainer">
                  <div className="LoginButton">
                    <ExtendedButton
                      Id={"loginButton"}
                      Width={173}
                      Usable={true} 
                      className={"loginButton"}  
                      Text={Vas.Resources.Labels["Login"]}  
                      OnClick={()=>{ this.login();}} />
                  </div>
                  <div className="LoginButtonCancel">
                    <ExtendedButton
                      Id={"cancelButton"}
                      Width={173}
                      Usable={true} 
                      className={"loginButton"}  
                      Text={Vas.Resources.Labels["Cancel"]} 
                      OnClick={()=> { Vas.GetView("Home", null, false);}} />
                  </div>
                </div>
                <div>
                  <LinkButton 
                    OnClick={()=>{this.ShowResetPassword();}} 
                    Id={'ResetPassword'} 
                    Text={Vas.Resources.Labels["PasswordForgotten"]} />
                </div>                        
              </div>
            </div>
          </div>
        );
    }
}
export default Login;
